import { useEffect, useState } from "react";
import {
    Box,
    Flex,
    Grid,
} from "@chakra-ui/react";
import {
    useDispatch,
    useSelector,
} from "react-redux";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import ProfileSummary from "./components/ProfileSummary";
import PersonalInformation from "./components/PersonalInformation";
import SecurityCard from "./components/SecurityCard";
import ReferralCard from "./components/ReferralCard";
import MarketplaceCard from "./components/MarketplaceCard";
import ProfileSkeleton from "./components/ProfileSkeleton";
import AccountManagement from "./components/AccountManagement";
import {
    fetchReferredDriversAction,
    fetchReferralMilestonesAction,
    fetchPendingCommissionsAction,
    fetchPartnerPayoutsAction
} from "../../state/actions/driverPartnerActions";

const Profile = () => {
        const dispatch =
        useDispatch();
const {
    driverPartner,
    referredDrivers = [],
    referralMilestones = [],
    partnerPayouts = [],
} = useSelector(
    (state) =>
        state.driverPartner
);

const [showSkeleton, setShowSkeleton] =
    useState(true);

useEffect(() => {
    const timer = setTimeout(() => {
        setShowSkeleton(false);
    }, 3000);

    return () => clearTimeout(timer);
}, []);
useEffect(() => {
    dispatch(fetchReferredDriversAction(1, 10));
    dispatch(fetchReferralMilestonesAction());
    dispatch(fetchPendingCommissionsAction(1, 100));

    if (driverPartner?.driver_partner_id) {
        dispatch(
            fetchPartnerPayoutsAction(
                driverPartner.driver_partner_id,
                1,
                100
            )
        );
    }
}, [
    dispatch,
    driverPartner?.driver_partner_id,
]);
const paidMilestoneEarnings =
    referralMilestones
        .filter(
            milestone =>
                milestone.commission_status ===
                "Paid"
        )
        .reduce(
            (sum, milestone) =>
                sum +
                Number(
                    milestone.commission_amount ||
                        0
                ),
            0
        );
const paidDeliveryEarnings =
    partnerPayouts
        .filter(
            payout =>
                payout.commission_id &&
                payout.status === "Paid"
        )
        .reduce(
            (sum, payout) =>
                sum + Number(payout.amount || 0),
            0
        );

const totalEarned =
    paidMilestoneEarnings +
    paidDeliveryEarnings;

const totalRecruits =
    referredDrivers.length;

    if (showSkeleton) {
    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
              marginBottom={{
        base: 20,
        md: 0,
    }}
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <ProfileSkeleton />
                </Box>
            </Flex>
        </Flex>
    );
}
    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
              marginBottom={{
        base: 20,
        md: 0,
    }}
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Profile & Settings"
                        subtitle="Manage your account details, recruit earnings, and security preferences."
                    />

                    {/* Top */}

                    <Grid
                        templateColumns={{
                            base: "1fr",
                            xl: "2fr 360px",
                        }}
                        gap={6}
                        alignItems="start"
                    >
                        {/* Left Column */}
                        <Flex
                            direction="column"
                            gap={6}
                        >
                            <ProfileSummary  driverPartner={
        driverPartner
    } />

                            <PersonalInformation  driverPartner={
        driverPartner
    } />

                            <SecurityCard />
                        </Flex>

                        {/* Right Column */}
                        <Flex
                            direction="column"
                            gap={6}
                        >
                            <ReferralCard
                                driverPartner={
                                    driverPartner
                                }
                                totalRecruits={
                                    totalRecruits
                                }
                                totalEarned={
                                    totalEarned
                                }
                            />
                         

                            <AccountManagement />
                        </Flex>
                    </Grid>
                </Box>
            </Flex>
        </Flex>
    );
};

export default Profile;